import React from 'react';
import PropTypes from 'prop-types';
import { X_AXIS_POINTS_BUFFER, X_AXIS_POINTS_SIZE } from './defaults.jsx';

export const XAxisPoints = ( props ) => {
    const { x1 } = props;
    return (
        <circle cx={ x1 } cy={ X_AXIS_POINTS_BUFFER } r={ X_AXIS_POINTS_SIZE }></circle>
    );
};

XAxisPoints.propTypes = {
	x1: PropTypes.number
};

export default XAxisPoints;